import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        outerContainer: {
            flexDir: 'column',
            paddingBottom: remCalc(24),
            gap: remCalc(24),
            borderBottom: 'small',
            borderStyle: 'solid',
            borderColor: 'border.light',
            w: '100%',
        },
        flexContainer: {
            gap: remCalc(24),
            w: '100%',
            flexDir: 'column',
        },
        formContainer: {
            flexDir: 'column',
            gap: remCalc(24),
        },
        vatInputContainer: {
            gap: remCalc(24),
            w: '100%',
        },
        inputContainer: {
            alignItems: 'flex-start',
            flexDirection: {base: 'column', md: 'row'},
            gap: remCalc(24),
            alignSelf: 'stretch',
            w: '100%',
            h: 'auto',
        },
        warningContainer: {
            minWidth: remCalc(343),
            flexDir: 'column',
            alignItems: 'flex-start',
            gap: remCalc(24),
            alignSelf: 'stretch',
        },
    },
}
